<template>
  <div class="guided-selection mx-auto flex w-full flex-col items-center">
    <h1 class="text-h1 centered mb-16 w-full">What are you looking to do today?</h1>
    <p class="text-body text-grey-body centered mb-40 w-full max-w-488">
      We'll guide you to the best way to <span class="linebreak">get started.</span>
    </p>
    <div class="w-full max-w-368" role="group" aria-label="Which of these apply to you?">
      <SelectableIconOptionCard
        v-for="option in selectionOptions"
        :key="option.value"
        :icon="option.icon"
        :label="option.label"
        :selected="selectedOption === option.value"
        @click="selectOption(option.value)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch, inject } from 'vue';
import SelectableIconOptionCard from '@/components/card/SelectableIconOptionCard.vue';
import { CORPORATE_GUIDED_SELECTION_OPTIONS, type CorporateGuidedDraft, type CorporateGuidedSelectionOption } from '../types';

const props = defineProps<{
  draft: CorporateGuidedDraft;
}>();

type NavigateToNextStep = (stepData?: Record<string, unknown>, draftData?: Record<string, unknown>) => Promise<void>;

const navigateToNextStep = inject<NavigateToNextStep>('navigateToNextStep', async () => {});

const selectedOption = ref<CorporateGuidedSelectionOption | null>(props.draft.selection ?? null);

const selectionOptions = computed(() => CORPORATE_GUIDED_SELECTION_OPTIONS);

watch(
  () => props.draft,
  (draft) => {
    if (draft.selection && draft.selection !== selectedOption.value) {
      selectedOption.value = draft.selection;
    }
  }
);

async function selectOption(selection: CorporateGuidedSelectionOption): Promise<void> {
  selectedOption.value = selection;
  await navigateToNextStep({}, { selection });
}
</script>
